export const ListViewTitle = ({
  title,
}: {
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <div className="tw:flex tw:justify-between tw:items-center">
      <div className="tw:text-[#001936] tw:leading-tight tw:text-[1.75rem] tw:lg:text-[3rem] tw:font-semibold tw:px-6 tw:pb-10">
        {title}
      </div>
    </div>
  );
};
